module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNzkuNDMyIiBoZWlnaHQ9IjU4MC4zMjYiIHZpZXdCb3g9IjAgMCAxNzkuNDMyIDU4MC4zMjYiPgogIDxwYXRoIGlkPSLjg5HjgrlfODk0NiIgZGF0YS1uYW1lPSLjg5HjgrkgODk0NiIgZD0iTTg1NS4wMjYtODcuNWwxNzkuNDMyLTY4LjAwN1YzNTYuODA5TDg1NS4wMjYsNDI0LjgxNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04NTUuMDI2IDE1NS41MSkiIGZpbGw9ImxpbWUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/green_179.svg
// module id = xU2H
// module chunks = 0